import _slicedToArray from "E:\\Agents\\Agent-02\\_work\\45\\s\\src\\apps\\vdsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import './SkipContentButtons.css';
import React, { useState } from 'react';
import { SitecoreContextReactContext } from '../../utils/SitecoreContextReactContext';
import { getGlobalDictionaryTerm } from '../../utils';
var SkipContentButtons = function SkipContentButtons() {
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    showbuttons = _useState2[0],
    setShowbuttons = _useState2[1];
  var sitecoreContext = React.useContext(SitecoreContextReactContext);
  var skipToContent = getGlobalDictionaryTerm(sitecoreContext, 'skipToContent') || "Skip to content";
  var skipToSearch = getGlobalDictionaryTerm(sitecoreContext, 'skipToSearch') || "Skip to search";
  var rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  var scrollContent = function scrollContent(e) {
    e.preventDefault();
    var main = document.querySelector('.main');
    var mainHeight = 0;
    if (main) {
      mainHeight = main.offsetTop;
      main.setAttribute('tabindex', "-1");
      main.focus();
    }
    window.scrollTo(0, mainHeight);
  };
  var keyupTContent = function keyupTContent(e) {
    if (e.keyCode === 32) {
      e.stopPropagation();
      scrollContent(e);
    }
  };
  var clickSearch = function clickSearch(e) {
    e.preventDefault();
    var search = document.querySelector('.search-box__link');
    if (search) {
      search.click();
    }
  };
  var keyupToSearch = function keyupToSearch(e) {
    if (e.keyCode === 13 || e.keyCode === 32) {
      e.stopPropagation();
      clickSearch(e);
    }
  };
  return /*#__PURE__*/React.createElement("div", {
    role: "navigation",
    className: "".concat(SkipContentButtonsStyles, " ").concat(rtl ? SkipContentButtonsStylesRtl : '', " ")
  }, /*#__PURE__*/React.createElement("div", {
    className: "rs_skip skipContent ".concat(showbuttons ? 'visible' : '')
  }, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "module-group"
  }, /*#__PURE__*/React.createElement("div", {
    className: "skipContent__row"
  }, /*#__PURE__*/React.createElement("button", {
    className: "skipContent__button",
    onKeyDown: function onKeyDown(e) {
      keyupTContent(e);
    },
    onClick: function onClick(e) {
      return scrollContent(e);
    },
    onFocus: function onFocus() {
      return setShowbuttons(true);
    },
    onBlur: function onBlur() {
      return setShowbuttons(false);
    }
  }, skipToContent), /*#__PURE__*/React.createElement("button", {
    className: "skipContent__button",
    onKeyDown: function onKeyDown(e) {
      keyupToSearch(e);
    },
    onClick: function onClick(e) {
      return clickSearch(e);
    },
    onFocus: function onFocus() {
      setShowbuttons(true);
    },
    onBlur: function onBlur() {
      return setShowbuttons(false);
    }
  }, skipToSearch))))));
};
var SkipContentButtonsStyles = "sondeyl";
var SkipContentButtonsStylesRtl = "s1sygn9v";
export default SkipContentButtons;